<template>
  <div class="committee">
    <div class="font-area" :class="globalTransition">
      <div class="title">
        <p>{{$t('projectPage.globalPartner.title')}}</p>
      </div>
      <p class="split-line">——</p>
      <div class="p1">
        <p>{{$t('projectPage.globalPartner.p1')}}<br>
        {{$t('projectPage.globalPartner.p2')}}<br>
       {{$t('projectPage.globalPartner.p3')}}</p>
      </div>
    </div>
    <div class="user">
<div v-for="event in 25" :key="event" class="user-item">
  <img :src='computeSrc(event)' class="img"/>
  </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'globalPartner',
  data() {
    return {
    };
  },
  computed: {
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
  methods: {
    computeSrc(event) {
      // eslint-disable-next-line
      return require(`../../assets/globalPartner/${event}.jpg`);
    },
  },
};
</script>

<style lang="scss" scoped>
  .committee{
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    padding:0px 10.5%;
    text-align: center;
  }
  .font-area{
    width: 70%;
    .title{
      font-size: 1.5rem;
      font-weight: bold;
    }
    .p1{
      font-size: 1.1rem;
      line-height: 2rem;
      white-space: nowrap;
    }
  }
  .user{
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 30px;
    padding-bottom: 5rem;
    justify-content: space-between;
    .user-item{
      background-color: #f6f6f6;
      width: 18%;
      margin: 1% 1%;
      display: flex;
      justify-content: center;
      align-items: center;
      .img{
        width: 100%;
      }
      .name{
        font-size: 1em;
        font-weight: bold;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/projectPage/globalPartner.vue